export const defineIsUseAry = [
  { value: '0', label: '禁用' },
  { value: '1', label: '启用' }
]
